<template>
  <button type="button" class="delete-btn">
    <slot>Удалить</slot>
  </button>
</template>

<script lang="ts" src="./DeleteTextBtn.ts"></script>

<style scoped lang="scss" src="./DeleteTextBtn.scss"></style>
